module.exports = __webpack_public_path__ + "img/bee__7.19c708e0.svg";